var _style, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunExposure({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EF9062;}\n\t.st1{fill:#EFC05D;}\n\t.st2{fill:#F6DAA2;}\n\t.st3{fill:#FFD881;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.63,184.22c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C28.34,149.93,62.94,184.22,105.63,184.22"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "97.68,142.44 85.09,150.27 83.38,135.54 68.63,137.14 73.46,123.12 59.48,118.15 69.93,107.62  59.48,97.1 73.46,92.13 68.63,78.11 83.37,79.71 85.09,64.98 97.68,72.81 105.63,60.3 113.58,72.81 126.17,64.98 127.89,79.7  142.63,78.11 137.81,92.13 151.78,97.09 141.34,107.62 151.78,118.15 137.81,123.12 142.64,137.13 127.89,135.54 126.18,150.27  113.59,142.44 105.63,154.95  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 105.63,
    cy: 107.62,
    r: 24.69
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M100.85,90.09c0,0.03-0.02,0.06-0.06,0.06l0,0h-0.11c-0.03,0-0.05-0.03-0.05-0.06c0-0.04,0.02-0.06,0.05-0.06 h0.11C100.83,90.03,100.85,90.05,100.85,90.09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunExposure);
export default __webpack_public_path__ + "static/media/Sun_exposure.ff55a6e61189aa84878852c300671734.svg";
export { ForwardRef as ReactComponent };